import React from "react";
import { FieldErrors, FieldValues } from "react-hook-form";
import { formComponentClasses } from "../../styles/componentClasses";

interface FormErrorsProps<T extends FieldValues> {
  errors: FieldErrors<T>;
}

export function FormErrors<T extends FieldValues>({ errors }: FormErrorsProps<T>) {
  const messages = Object.values(errors)
    .map((e) => (e as { message?: string })?.message)
    .filter((m): m is string => !!m);

  if (messages.length === 0) return null;

  return (
    <ul className={formComponentClasses.errors}>
      {messages.map((msg, i) => (
        <li key={i}>{msg}</li>
      ))}
    </ul>
  );
}
